import { typeGuardHelpers } from '@approvalmax/utils';
import { useMemo } from 'react';
import { messages } from 'shared/constants/countryNames';
import { useGetBusinessCountries } from 'shared/data/walletsKyc/v1';

export const useCompanyCountries = () => {
    const { data, isLoading } = useGetBusinessCountries();

    const countries = useMemo(
        () =>
            (data?.items || []).map((country) => ({
                id: country.countryCode,
                name: typeGuardHelpers.isKeyOfObject(country.countryCode, messages)
                    ? messages[country.countryCode]
                    : country.countryName,
            })),
        [data?.items]
    );

    return {
        countries,
        isCountriesLoading: isLoading,
    };
};
